/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/Inputs/Content/Status/Content"
  
}) {
let dataValueData = fromData.useDataFormat({ viewPath,
context: 'data',
format: fromHelpers.getColor,
})
let dataValueData1 = fromData.useDataFormat({ viewPath,
context: 'data',
format: fromFormat.toLowerCase,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textTransform="capitalize"
 data="data"
 format="helpers.js getColor"
 color={dataValueData}
 data="data"
 format="/Data/format.js toLowerCase"
 text={dataValueData1}
/>
{children}
</React.Fragment>)
}